import type { LucideIcon } from "lucide-react";
import {
  Briefcase,
  ClipboardCheck,
  FileText,
  FolderOpen,
  LockKeyhole,
  ShoppingBag,
} from "lucide-react";
import type { ProfileGestionSection } from "../../../../utils/navigationHelpers.ts";

export interface GestionHubItem {
  section: ProfileGestionSection;
  title: string;
  description: string;
  icon: LucideIcon;
  teaser?: boolean;
}

export const GESTION_TEASER_SECTIONS: ProfileGestionSection[] = ["documentaciones"];

export const isGestionTeaserSection = (section: ProfileGestionSection) =>
  GESTION_TEASER_SECTIONS.includes(section);

export interface GestionHubGroup {
  id: string;
  label: string;
  items: GestionHubItem[];
}

export const GESTION_HUB_GROUPS: GestionHubGroup[] = [
  {
    id: "obra",
    label: "Obra",
    items: [
      {
        section: "accesos",
        title: "Accesos a obras",
        description: "Solicitudes de acceso a obras privadas de otros usuarios.",
        icon: LockKeyhole,
      },
      {
        section: "proyectos",
        title: "Proyectos publicados",
        description: "Obras privadas que publicaste y su gestión.",
        icon: FolderOpen,
      },
      {
        section: "documentaciones",
        title: "Documentaciones de obra",
        description: "Centralizá planos, memorias y archivos de obra. Próximamente.",
        icon: FileText,
        teaser: true,
      },
    ],
  },
  {
    id: "materiales",
    label: "Materiales",
    items: [
      {
        section: "cotizaciones",
        title: "Cotización de materiales",
        description: "Cotizaciones que enviaste y respuestas recibidas.",
        icon: FileText,
      },
    ],
  },
  {
    id: "trabajo",
    label: "Trabajo",
    items: [
      {
        section: "avisos-laborales",
        title: "Mis avisos laborales",
        description: "Vacantes que publicaste y postulantes recibidos.",
        icon: Briefcase,
      },
      {
        section: "postulaciones-laborales",
        title: "Postulaciones laborales",
        description: "Vacantes del mercado de trabajo a las que te postulaste.",
        icon: ClipboardCheck,
      },
    ],
  },
  {
    id: "comercio",
    label: "Comercio",
    items: [
      {
        section: "comercio",
        title: "Mi comercio",
        description: "Catálogo, precios y configuración de tu comercio.",
        icon: ShoppingBag,
      },
    ],
  },
];
